var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"header"},[_vm._t("header")],2),_c('div',{staticClass:"content"},[_vm._t("content"),_vm._t("default")],2),_c('div',{staticClass:"footer"},[_vm._t("footer")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }